import {Font, StyleSheet} from '@react-pdf/renderer';

import {greenColors} from '../../../../../../layouts/theme/designSystem';

Font.registerEmojiSource({
  format: 'png',
  url: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/72x72/',
});

export const sharedStyles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#0E2225',
    padding: 6,
  },
  leftSection: {
    margin: 6,
  },
  h1: {
    fontSize: 32,
    fontWeight: 'bold',
    color: `${greenColors[700]}`,
  },
  h2: {
    fontSize: 14,
    color: `${greenColors[700]}`,
  },
  h3: {
    fontSize: 12,
    color: `${greenColors[700]}`,
  },
  h4: {
    fontSize: 10,
    color: `${greenColors[700]}`,
  },
  text: {
    fontSize: 10,
    color: `${greenColors[700]}`,
    lineHeight: 1.5,
  },
  body1: {
    fontSize: 8,
    color: `${greenColors[700]}`,
  },
  profileImage: {
    height: 80,
    width: 80,
    borderRadius: '50%',
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
  },
});
